import styled from "@emotion/styled";
var Container = /*#__PURE__*/ styled("section", {
    target: "e31xg1d0"
})("display:flex;flex-direction:column;gap:6rem;justify-content:space-around;margin:0 auto;");
export { Container };
